import { TypographyProps } from '@serko/zui/es/Typography';
import React, { FunctionComponent } from 'react';
import pure from 'recompose/pure';
import { ResponsiveTypography } from '../ResponsiveTypography';

interface OwnProps extends TypographyProps {}

export interface SectionHeaderTextProps extends OwnProps {}

const SectionHeaderTextBase: FunctionComponent<
  SectionHeaderTextProps
> = props => (
  <ResponsiveTypography
    variantMd="headline"
    variantXs="title"
    align="center"
    {...props}
  />
);

export const SectionHeaderText = pure(SectionHeaderTextBase);

SectionHeaderText.displayName = 'SectionHeaderText';
